export default "__VITE_ASSET__ByjsS2Ts__"